import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './Settings.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import { Link,useNavigate } from 'react-router-dom';

const Settings = () => {
    const navigate = useNavigate();
    useEffect(() => {
        document.title = `Settings | Local Bells`;
        document.getElementById('bodywrap').className = 'nesetting';
    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='setting-box'>
                                    <Row className='mx-0'>
                                        <Col md={8} lg={8} xl={8} xxl={6}>
                                            <div className='white-box'>
                                                <div className="d-flex align-items-start justify-content-between gap-3">
                                                    <h3>Settings</h3>
                                                    <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                    </Link>
                                                </div>
                                                <h6>Account settings</h6>
                                                <div className='setting-single-box'>
                                                    <h6>Notification</h6>
                                                    <Form.Check
                                                        type="switch"
                                                        id="notifications"
                                                        checked
                                                    />
                                                </div>
                                                <div className='setting-single-box'>
                                                    <h6>Receive email alerts</h6>
                                                    <Form.Check
                                                        type="switch"
                                                        id="email"
                                                    />
                                                </div>
                                                <h6 className='mt-4'>Privacy settings</h6>
                                                <div className='setting-single-box setting-mail-box'>
                                                    <div>
                                                        <h6>Email Address</h6>
                                                        <h6>Verify</h6>
                                                    </div>
                                                    <div>
                                                        <p>The email address associated with your account.</p>
                                                        <p>localuser@gmail.com</p>
                                                    </div>
                                                </div>
                                                <Button variant="primary" className='red-icn-btn' type="button">
                                                    <h6>Delete Account</h6> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/delete.webp'} className="img-fluid" alt="delete" />
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                  
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Settings;


